import Store from '../store/Store';
import { ASSET_LIST_BLOCK_INSTANCE, PWD } from '../store/Constants';
import _ from 'lodash';
import { func } from 'prop-types';

export function forceUpdateStatus(items, forceUpdateStatusOfAll) {
  const object = getListBlockInstance();
  if (object) {
    object.forceUpdateStatus(items, forceUpdateStatusOfAll);
  }
}

export function forceReRender() {
  const object = getListBlockInstance();
  if (object) {
    object.reRenderAssets();
  }
}

export function issueRefresh() {
  const object = getListBlockInstance();
  if (object) {
    object.onRefreshClick();
  }
}

export function clearSelectedItems() {
  const object = getListBlockInstance();
  if (object) {
    object.clearSelectedItems();
  }
}

export function getListBlockInstance() {
  return Store.get(ASSET_LIST_BLOCK_INSTANCE);
}

export function updateLockStatus(items, stat) {
  if (items) {
    _.each(items, (item) => {
      item.setIsLocked(stat);
    });
    forceReRender();
  }
}

export function onDeletedSuccessfully(items, forceRemove = false) {
  const object = getListBlockInstance();
  if (object) {
    object.onDeleteSuccess(items, forceRemove);
  }
}

export function onResurrected(items) {
  items.forEach((asset) => {
    asset.setIsDeleted(false);
  });

  if (isCurrentNodeSelectedOnTree(items) && window.gs.onParentSelection) {
    window.gs.onParentSelection();
  } else {
    issueRefresh();
  }
}

export function isCurrentNodeSelectedOnTree(items) {
  const pwd = Store.get(PWD);
  if (pwd && pwd.length) {
    const currentNode = _.last(pwd);
    if (items.length === 1 && items[0].getFuid() === currentNode) return true;
  }
  return false;
}

export function clearSelectedItem(fuids) {
  window.gs.selectedAssets = window.gs.selectedAssets.filter((a) => !_.includes(fuids, a.getFuid()));
  console.log(window.gs.selectedAssets);
}
